import NewBookingPage from './new-booking-page';

export default NewBookingPage;
